window.GMap ?= {}

GMap.vent = vent =
  _(Backbone.Events).clone()

GMap._start = _start = ->
  GMap.vent.trigger('start')


module.exports = {vent, _start}
